function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { objectToArrayOfObjects } from '@finect/front-utils/objectToArrayOfObjects';
import { APP_SET_APP_FETCHING_STATUS, APP_SET_APP, APP_SET_APP_FIELD_VALUE, APP_SET_SESSION, APP_SET_LAST_SESSION, APP_EDIT_LAST_SESSION_FIELD, APP_CLEAR } from './constants';
export function apps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    apps: [],
    lastSessions: [],
    sessions: []
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case APP_SET_LAST_SESSION:
      {
        return _objectSpread(_objectSpread({}, state), {
          lastSessions: [].concat(_toConsumableArray(state.lastSessions.filter(function (_ref) {
            var id = _ref.id;
            return id !== action.app;
          })), [{
            id: action.app,
            fetching: false,
            fetched: true,
            model: action.lastSession
          }])
        });
      }
    case APP_EDIT_LAST_SESSION_FIELD:
      {
        var app = state.lastSessions.find(function (_ref2) {
          var id = _ref2.id;
          return id === action.app;
        }) ? state.lastSessions.find(function (_ref3) {
          var id = _ref3.id;
          return id === action.app;
        }) : {
          id: action.app,
          fetching: false,
          fetched: false,
          model: {
            id: action.id || null,
            created: new Date().toISOString(),
            updated: new Date().toISOString(),
            status: action.status,
            application: {
              id: action.app,
              description: '',
              type: 'forms'
            },
            items: objectToArrayOfObjects(action.fields, 'field', 'value')
          }
        };
        var newModel = _objectSpread(_objectSpread({}, app.model), {
          id: action.id || app.model.id || null,
          status: action.status,
          items: objectToArrayOfObjects(action.fields, 'field', 'value')
        });
        var newApp = _objectSpread(_objectSpread({}, app), {}, {
          model: _objectSpread({}, newModel)
        });
        var newLastSessions = [].concat(_toConsumableArray(state.lastSessions.filter(function (_ref4) {
          var id = _ref4.id;
          return id !== action.app;
        })), [newApp]);
        return _objectSpread(_objectSpread({}, state), {
          lastSessions: newLastSessions
        });
      }
    case APP_SET_APP_FETCHING_STATUS:
      {
        var _app = state.apps.find(function (_ref5) {
          var id = _ref5.id;
          return id === action.id;
        });
        var _newApp = _app ? _objectSpread(_objectSpread({}, _app), {
          id: action.id,
          fetching: action.fetching,
          fetched: action.fetched
        }) : {
          id: action.id,
          fetching: action.fetching,
          fetched: action.fetched,
          model: null
        };
        return _objectSpread(_objectSpread({}, state), {
          apps: [].concat(_toConsumableArray(state.apps.filter(function (_ref6) {
            var id = _ref6.id;
            return id !== action.id;
          })), [_newApp])
        });
      }
    case APP_SET_APP:
      {
        return _objectSpread(_objectSpread({}, state), {
          apps: [].concat(_toConsumableArray(state.apps.filter(function (_ref7) {
            var id = _ref7.id;
            return id !== action.app.id;
          })), [{
            id: action.app.id,
            fetching: false,
            fetched: true,
            model: action.app
          }])
        });
      }
    case APP_SET_APP_FIELD_VALUE:
      {
        var _app2 = state.apps.find(function (_ref8) {
          var id = _ref8.id;
          return id === action.app;
        });
        var field = _app2.model.fields.find(function (item) {
          return item.field === action.field;
        });
        var lastValue = field.lastValue ? _objectSpread(_objectSpread({}, field.lastValue), {
          value: action.value
        }) : {
          value: action.value,
          application: {},
          date: new Date().toISOString()
        };
        var newField = _objectSpread(_objectSpread({}, field), {
          lastValue: lastValue
        });
        var _newApp2 = _objectSpread(_objectSpread({}, _app2), {
          model: _objectSpread(_objectSpread({}, _app2.model), {
            fields: [].concat(_toConsumableArray(_app2.model.fields.filter(function (item) {
              return item.field !== action.field;
            })), [newField])
          })
        });
        return _objectSpread(_objectSpread({}, state), {
          apps: [].concat(_toConsumableArray(state.apps.filter(function (item) {
            return item.id !== action.app;
          })), [_newApp2])
        });
      }
    case APP_SET_SESSION:
      {
        var sessions = _toConsumableArray(state.sessions.filter(function (item) {
          return item.application.id !== action.session.application.id;
        }));
        return _objectSpread(_objectSpread({}, state), {
          sessions: [].concat(_toConsumableArray(sessions), [action.session])
        });
      }
    case APP_CLEAR:
      {
        return {
          apps: [],
          lastSessions: [],
          sessions: []
        };
      }
    default:
      return state;
  }
}